import { Type, type Static } from '@sinclair/typebox';
import { FIELD_LIMITS } from '../constants.js';
import { RowVersionField, SoftDeleteFields, TimestampFields, UuidSchema } from './common.js';

// ---------------------------------------------------------------------------
// Read shape
// ---------------------------------------------------------------------------

export const SupplierSchema = Type.Object({
  id: UuidSchema,
  name: Type.String({ minLength: 1, maxLength: FIELD_LIMITS.NAME_MAX }),
  address: Type.Union([Type.String({ maxLength: FIELD_LIMITS.ADDRESS_MAX }), Type.Null()]),
  categoryId: Type.Union([UuidSchema, Type.Null()]),
  subcategoryId: Type.Union([UuidSchema, Type.Null()]),
  contactPerson: Type.Union([Type.String({ maxLength: FIELD_LIMITS.NAME_MAX }), Type.Null()]),
  officialPhone: Type.Union([Type.String({ maxLength: FIELD_LIMITS.PHONE_MAX }), Type.Null()]),
  personalPhone: Type.Union([Type.String({ maxLength: FIELD_LIMITS.PHONE_MAX }), Type.Null()]),
  notes: Type.Union([Type.String({ maxLength: FIELD_LIMITS.NOTES_MAX }), Type.Null()]),
  isActive: Type.Boolean(),
  ...TimestampFields,
  ...SoftDeleteFields,
  ...RowVersionField,
});
export type Supplier = Static<typeof SupplierSchema>;

// ---------------------------------------------------------------------------
// Create / update inputs
// ---------------------------------------------------------------------------

export const SupplierCreateSchema = Type.Object({
  name: Type.String({ minLength: 1, maxLength: FIELD_LIMITS.NAME_MAX }),
  address: Type.Optional(Type.String({ maxLength: FIELD_LIMITS.ADDRESS_MAX })),
  categoryId: Type.Optional(Type.Union([UuidSchema, Type.Null()])),
  subcategoryId: Type.Optional(Type.Union([UuidSchema, Type.Null()])),
  contactPerson: Type.Optional(Type.String({ maxLength: FIELD_LIMITS.NAME_MAX })),
  officialPhone: Type.Optional(Type.String({ maxLength: FIELD_LIMITS.PHONE_MAX })),
  personalPhone: Type.Optional(Type.String({ maxLength: FIELD_LIMITS.PHONE_MAX })),
  notes: Type.Optional(Type.String({ maxLength: FIELD_LIMITS.NOTES_MAX })),
});
export type SupplierCreate = Static<typeof SupplierCreateSchema>;

export const SupplierUpdateSchema = Type.Object({
  name: Type.Optional(Type.String({ minLength: 1, maxLength: FIELD_LIMITS.NAME_MAX })),
  address: Type.Optional(
    Type.Union([Type.String({ maxLength: FIELD_LIMITS.ADDRESS_MAX }), Type.Null()]),
  ),
  categoryId: Type.Optional(Type.Union([UuidSchema, Type.Null()])),
  subcategoryId: Type.Optional(Type.Union([UuidSchema, Type.Null()])),
  contactPerson: Type.Optional(
    Type.Union([Type.String({ maxLength: FIELD_LIMITS.NAME_MAX }), Type.Null()]),
  ),
  officialPhone: Type.Optional(
    Type.Union([Type.String({ maxLength: FIELD_LIMITS.PHONE_MAX }), Type.Null()]),
  ),
  personalPhone: Type.Optional(
    Type.Union([Type.String({ maxLength: FIELD_LIMITS.PHONE_MAX }), Type.Null()]),
  ),
  notes: Type.Optional(
    Type.Union([Type.String({ maxLength: FIELD_LIMITS.NOTES_MAX }), Type.Null()]),
  ),
  isActive: Type.Optional(Type.Boolean()),
  rowVersion: Type.Integer({ minimum: 0 }),
});
export type SupplierUpdate = Static<typeof SupplierUpdateSchema>;
